module.exports = __webpack_public_path__ + "assets/4e68ecc2bd4fec473ab0f92bcba69c35.png";